function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3.16667H3.33333C2.41286 3.16667 1.66666 3.91286 1.66666 4.83333V14.8333C1.66666 15.7538 2.41286 16.5 3.33333 16.5H11.6667C12.5871 16.5 13.3333 15.7538 13.3333 14.8333M5 3.16667C5 4.08714 5.74619 4.83333 6.66666 4.83333H8.33333C9.25381 4.83333 10 4.08714 10 3.16667M5 3.16667C5 2.24619 5.74619 1.5 6.66666 1.5H8.33333C9.25381 1.5 10 2.24619 10 3.16667M10 3.16667H11.6667C12.5871 3.16667 13.3333 3.91286 13.3333 4.83333V6.5M18.3333 10.6667H7.5M7.5 10.6667L10 8.16667M7.5 10.6667L10 13.1667",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgClipboardLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardLeft);
export default __webpack_public_path__ + "static/media/clipboard-left.ce4c72ff.svg";
export { ForwardRef as ReactComponent };